<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="groupNameFilter">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="groupName"></wbo-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
